(function() {
  var config = window.MKFavoritesConfig || {};
  var customerId = config.customerId || null;
  var isLoggedIn = Boolean(customerId);
  var favoritesPageUrl = config.favoritesPageUrl || '/pages/favoris';
  var loginUrl = config.loginUrl || '/account/login';
  var storageKey = 'mk:favorites:' + (customerId || 'guest');

  function normalizeList(list) {
    if (!Array.isArray(list)) return [];
    var seen = Object.create(null);
    var out = [];
    list.forEach(function(item) {
      if (typeof item !== 'string') return;
      var handle = item.trim();
      if (!handle || seen[handle]) return;
      seen[handle] = true;
      out.push(handle);
    });
    return out;
  }

  function read() {
    try {
      return normalizeList(JSON.parse(localStorage.getItem(storageKey) || '[]'));
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    var safe = normalizeList(list);
    localStorage.setItem(storageKey, JSON.stringify(safe));
    document.dispatchEvent(new CustomEvent('mk:favorites:updated', { detail: { handles: safe.slice() } }));
    return safe;
  }

  function loginWithReturn() {
    var url = new URL(loginUrl, window.location.origin);
    url.searchParams.set('return_url', window.location.pathname + window.location.search + window.location.hash);
    window.location.assign(url.href);
  }

  function isFavorited(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    if (!isLoggedIn) {
      loginWithReturn();
      return false;
    }
    var items = read();
    var index = items.indexOf(handle);
    if (index === -1) {
      items.unshift(handle);
    } else {
      items.splice(index, 1);
    }
    write(items);
    return true;
  }

  function remove(handle) {
    var items = read().filter(function(item) { return item !== handle; });
    write(items);
  }

  function move(handle, direction) {
    var items = read();
    var index = items.indexOf(handle);
    if (index === -1) return;
    var target = direction === 'up' ? index - 1 : index + 1;
    if (target < 0 || target >= items.length) return;
    var tmp = items[target];
    items[target] = items[index];
    items[index] = tmp;
    write(items);
  }

  function syncButtons() {
    document.querySelectorAll('[data-favorite-toggle]').forEach(function(button) {
      var handle = button.getAttribute('data-product-handle');
      if (!handle) return;
      var active = isFavorited(handle);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function fetchFavoriteCard(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?view=favorite-card', { credentials: 'same-origin' })
      .then(function(response) {
        if (!response.ok) throw new Error('Failed product card fetch');
        return response.text();
      })
      .then(function(html) {
        return String(html || '').trim();
      });
  }

  function renderFavoritesPage() {
    var root = document.querySelector('[data-favorites-page]');
    if (!root) return;
    var listNode = root.querySelector('[data-favorites-list]');
    var emptyNode = root.querySelector('[data-favorites-empty]');
    var loginNode = root.querySelector('[data-favorites-login]');
    if (!listNode || !emptyNode || !loginNode) return;

    var columnsDesktop = parseInt(root.getAttribute('data-favorites-columns-desktop') || '3', 10);
    var columnsMobile = parseInt(root.getAttribute('data-favorites-columns-mobile') || '1', 10);
    if (Number.isFinite(columnsDesktop) && columnsDesktop > 0) {
      listNode.style.setProperty('--favorites-columns-desktop', String(columnsDesktop));
    }
    if (Number.isFinite(columnsMobile) && columnsMobile > 0) {
      listNode.style.setProperty('--favorites-columns-mobile', String(columnsMobile));
    }

    if (!isLoggedIn) {
      loginNode.hidden = false;
      emptyNode.hidden = true;
      listNode.innerHTML = '';
      return;
    }

    loginNode.hidden = true;
    var handles = read();
    if (!handles.length) {
      emptyNode.hidden = false;
      listNode.innerHTML = '';
      return;
    }

    emptyNode.hidden = true;
    Promise.all(handles.map(fetchFavoriteCard))
      .then(function(cardsHtml) {
        listNode.innerHTML = cardsHtml.join('');
        syncButtons();
      })
      .catch(function() {
        listNode.innerHTML = '';
        emptyNode.hidden = false;
      });
  }

  document.addEventListener('click', function(event) {
    var toggleBtn = event.target.closest('[data-favorite-toggle]');
    if (toggleBtn) {
      event.preventDefault();
      var handle = toggleBtn.getAttribute('data-product-handle');
      if (!handle) return;
      if (toggle(handle) === false) return;
      syncButtons();
      renderFavoritesPage();
      return;
    }

    var moveBtn = event.target.closest('[data-favorite-move]');
    if (moveBtn) {
      event.preventDefault();
      var moveHandle = moveBtn.getAttribute('data-product-handle');
      var direction = moveBtn.getAttribute('data-favorite-move');
      if (!moveHandle || !direction) return;
      move(moveHandle, direction);
      renderFavoritesPage();
      return;
    }

  });

  document.addEventListener('DOMContentLoaded', function() {
    syncButtons();
    renderFavoritesPage();
  });

  document.addEventListener('mk:favorites:updated', function() {
    syncButtons();
  });

  window.MKFavorites = {
    read: read,
    write: write,
    remove: remove,
    move: move,
    isFavorited: isFavorited,
    favoritesPageUrl: favoritesPageUrl
  };
})();
